import { useState } from "react";
import { Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { api, errMsg } from "@/lib/api";
import { DangerDialog } from "@/components/core/DangerDialog";

export const useSelection = () => {
  const [sel, setSel] = useState([]);
  const toggle = (id) => setSel((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  const toggleAll = (ids) => setSel((p) => (ids.every((i) => p.includes(i)) ? [] : ids));
  return { sel, toggle, toggleAll, clear: () => setSel([]) };
};

export const SelectAll = ({ ids, selection, testid }) => (
  <Checkbox checked={ids.length > 0 && ids.every((i) => selection.sel.includes(i))} onCheckedChange={() => selection.toggleAll(ids)} aria-label="Seleziona tutti" data-testid={testid} />
);

export const SelectOne = ({ id, selection, testid }) => (
  <Checkbox checked={selection.sel.includes(id)} onCheckedChange={() => selection.toggle(id)} onClick={(e) => e.stopPropagation()} aria-label="Seleziona" data-testid={testid} />
);

const LABEL = { documenti: "documenti", task: "task", post: "post PED" };

export const BulkBar = ({ tipo, selection, onDone }) => {
  const [open, setOpen] = useState(false);
  const n = selection.sel.length;
  if (!n) return null;
  const confirm = async (conferma) => {
    try {
      const r = await api.post(`/bulk/${tipo}/elimina`, { ids: selection.sel, conferma });
      toast.success(`${r.data.deleted} ${LABEL[tipo]} eliminati`); selection.clear(); setOpen(false); onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex items-center gap-3 rounded-2xl bg-[#0A1128] text-white px-4 py-2.5 mb-3" data-testid={`bulk-bar-${tipo}`}>
      <span className="font-bold text-sm" data-testid={`bulk-count-${tipo}`}>{n} selezionati</span>
      <Button size="sm" onClick={() => setOpen(true)} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid={`bulk-delete-${tipo}`}><Trash2 className="h-4 w-4 mr-1" />Elimina selezionati</Button>
      <button onClick={selection.clear} className="ml-auto text-white/80 hover:text-white inline-flex items-center gap-1 text-sm" data-testid={`bulk-clear-${tipo}`}><X className="h-4 w-4" />Deseleziona</button>
      <DangerDialog open={open} onOpenChange={setOpen} title={`Eliminare ${n} ${LABEL[tipo]}?`} items={[{ key: tipo, label: `${LABEL[tipo][0].toUpperCase()}${LABEL[tipo].slice(1)} selezionati`, count: n }]}
        warning={tipo !== "documenti" ? "Verranno eliminati anche i relativi commenti interni." : null} onConfirm={confirm} />
    </div>
  );
};
